import React from 'react';

import Header from '@/components/Header/Header';
import Screen from '@/components/Screen/Screen';
import Space from '@/components/Space/Space';
import Text from '@/components/Text/Text';
import {useAnimatedHeader} from '@/hooks/useAnimatedHeader';
import {useAppSelector} from '@/hooks/useRedux';
import {selectActiveUserId} from '@/store/user';

import ReleasesForYou from './components/ReleasesForYou';

const ReleasesForYouScreen = () => {
  const {scrollPosition, onScroll} = useAnimatedHeader();

  const myUserId = useAppSelector(selectActiveUserId);

  const renderContent = () => {
    if (!myUserId) {
      // Our user ID does not exist yet and we need it because we're not impersonating
      // another user. This can happen in two ways:
      // 1. the user launched the app while offline and has never been online
      // 2. the user is online for the first time but we haven't got them a spindexer user
      //   yet (eg in the first seconds of opening the app for the first time)
      return (
        <Space m="m">
          <Text id="releasesForYou.noUser" style={{textAlign: 'center'}} />
        </Space>
      );
    }

    return (
      <>
        <Header
          titleId="releasesForYou.title"
          showBack
          scrollPosition={scrollPosition}
          mockTitle={true}
        />

        <ReleasesForYou userId={myUserId} onScroll={onScroll} />
      </>
    );
  };

  return <Screen>{renderContent()}</Screen>;
};

export default ReleasesForYouScreen;
